import { TDevice } from '@cian/utils';

export function isAddFormMobileModeEnabled(deviceType: TDevice): boolean {
  return ['phone', 'tablet'].includes(deviceType);
}
